import React from 'react';

export default function FreezedIcon({width = '20px', height = '20px', flex = 'none'}) {
  return (
    <svg style={{width, height, flex}} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M13.625 7.25H13.1667V5.5C13.1667 3.5697 11.5222 2 9.5 2C7.47778 2 5.83333 3.5697 5.83333 5.5V7.25H5.375C4.61723 7.25 4 7.83853 4 8.5625V14.6875C4 15.4115 4.61723 16 5.375 16H13.625C14.3828 16 15 15.4115 15 14.6875V8.5625C15 7.83853 14.3828 7.25 13.625 7.25ZM7.05559 5.5C7.05559 4.21313 8.15186 3.1667 9.5 3.1667C10.8481 3.1667 11.9444 4.21313 11.9444 5.5V7.25H7.05559V5.5Z" fill="#8E0CF5"/>
    </svg>
  );
}